import { QarepaEnumInformation } from '@qarepa/common';

export enum CheckActionEnum {
  LIVE = 'LIVE',
  MANUAL = 'MANUAL',
}

export const CheckActionInfo: QarepaEnumInformation<CheckActionEnum> = {
  [CheckActionEnum.LIVE]: {
    name: $localize`En vivo`,
  },
  [CheckActionEnum.MANUAL]: {
    name: $localize`Manual`,
  },
};
